import {
  calculateVolumeAndUnits,
  canUseFractionedQuantity,
  convertVolumeAndUnitsToQuantity,
  formatQuantityToVolumeAndUnits,
} from '../../../../services/util/volume-and-units.service'

function normalizeLabel(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function roundToTwo(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100
}

export function getInventarioQuantityConfig(item = {}) {
  const unitSku = Number(item.unit_sku || 0)
  const caixaComPesoVariavel =
    item.caixa_com_peso_variavel === true || Number(item.caixa_com_peso_variavel) === 1

  return {
    unitSku,
    caixaComPesoVariavel,
    unAgregadora: item.un_agregadora || null,
    unFracionada: item.un_fracionada || null,
    canUseFractionedInput: canUseFractionedQuantity(unitSku, caixaComPesoVariavel),
  }
}

export function getInventarioInputLabels(item) {
  const { unAgregadora, unFracionada } = getInventarioQuantityConfig(item)

  return {
    volumeLabel: normalizeLabel(unAgregadora) || 'Vol.',
    unitsLabel: normalizeLabel(unFracionada) || 'Frac.',
  }
}

export function buildInventarioQuantityInputState(item, quantity) {
  const { unitSku, caixaComPesoVariavel } = getInventarioQuantityConfig(item)

  if (quantity === '' || quantity === null || quantity === undefined) {
    return {
      quantityValue: '',
      volumeValue: '',
      unitsValue: '',
    }
  }

  const { volume, units } = calculateVolumeAndUnits(quantity, unitSku, caixaComPesoVariavel)

  return {
    quantityValue: Number(quantity),
    volumeValue: volume === 0 ? '0' : String(volume),
    unitsValue: units === 0 ? '0' : String(Math.abs(units)),
  }
}

export function getInventarioQuantityValueFromInputs(item, volumeValue, unitsValue) {
  const { unitSku, caixaComPesoVariavel, canUseFractionedInput } = getInventarioQuantityConfig(item)

  if (volumeValue === '' && (unitsValue === '' || !canUseFractionedInput || caixaComPesoVariavel)) {
    return ''
  }

  return convertVolumeAndUnitsToQuantity({
    volume: volumeValue,
    units: canUseFractionedInput ? unitsValue : 0,
    unitSku,
    caixaComPesoVariavel,
  })
}

export function getInventarioQuantityVolumeAndUnits(item, quantity) {
  const { unitSku, caixaComPesoVariavel, unAgregadora, unFracionada } =
    getInventarioQuantityConfig(item)
  const { volume, units } = calculateVolumeAndUnits(quantity, unitSku, caixaComPesoVariavel)

  return {
    volume,
    units,
    volumeText: volume === 0 && units < 0 ? '-0' : String(volume),
    unitsText: String(units),
    customVolumeLabel: normalizeLabel(unAgregadora) || null,
    customUnitsLabel: normalizeLabel(unFracionada) || null,
  }
}

export function formatInventarioQuantity(item, quantity) {
  const { unitSku, caixaComPesoVariavel, unAgregadora, unFracionada, canUseFractionedInput } =
    getInventarioQuantityConfig(item)

  if (!canUseFractionedInput) {
    const parsed = Number(quantity)
    return Number.isFinite(parsed) ? String(roundToTwo(parsed)) : String(quantity || 0)
  }

  return formatQuantityToVolumeAndUnits({
    quantity,
    unitSku,
    caixaComPesoVariavel,
    unAgregadora,
    unFracionada,
  })
}
